import { useState, useEffect } from "react";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getApp } from "firebase/app";

const useFinanciaciones = () => {
  const [financiaciones, setFinanciaciones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const db = getFirestore(getApp());
        const docRef = doc(db, "financiaciones", "datos"); // <-- Cambia "main" por el ID real si es otro
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setFinanciaciones(docSnap.data().datos || []);
        } else {
          setFinanciaciones([]);
        }
      } catch (e) {
        setFinanciaciones([]);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  return { financiaciones, loading };
};

export default useFinanciaciones;
